import { addAction } from "../../../tools/ddLog";
import { Logger } from "../../../tools/Logger";

const TAG = "PRIVACYVIDEO";
const RUM_INTERVAL_MS = 10_000;

const lastSuccessAt = new Map<string, number>();
const lastNoRoiAt = new Map<string, number>();
const lastDegradedReason = new Map<string, string>();

/** Blur compositing actually applied (cyan ROI present). */
export function recordPrivacySuccess(uavId: string, processMs: number): void {
  const now = Date.now();
  if (now - (lastSuccessAt.get(uavId) || 0) < RUM_INTERVAL_MS) {
    return;
  }
  lastSuccessAt.set(uavId, now);
  lastDegradedReason.delete(uavId);
  try {
    addAction("privacy_blur_success", {
      uavId,
      worker_process_ms: processMs,
    });
  } catch {
    /* metrics must never affect video */
  }
}

/**
 * Blur is enabled but no cyan ROI is locked, so the feed stays raw
 * (optionally with person boxes). Replaces the old centre-only path.
 */
export function recordPrivacyNoRoiRaw(uavId: string): void {
  const now = Date.now();
  if (now - (lastNoRoiAt.get(uavId) || 0) < RUM_INTERVAL_MS) {
    return;
  }
  lastNoRoiAt.set(uavId, now);
  Logger.info(TAG, "no cyan ROI — showing raw video", { uavId });
  try {
    addAction("privacy_no_roi_raw", { uavId });
  } catch {
    /* metrics must never affect video */
  }
}

export function recordPrivacyDegraded(
  uavId: string,
  reason: string,
  extra?: Record<string, unknown>
): void {
  Logger.warn(TAG, `degraded_to_full_blur: ${reason}`, {
    uavId,
    reason,
    ...extra,
  });
  if (lastDegradedReason.get(uavId) === reason) {
    return;
  }
  lastDegradedReason.set(uavId, reason);
  try {
    addAction("privacy_degraded_full_blur", { uavId, reason, ...extra });
  } catch {
    /* metrics must never affect video */
  }
}

/**
 * Person detection turned itself off for a stream. Blur is unaffected, so this
 * is a capability loss rather than a privacy fallback.
 */
export function recordPrivacyDetectDisabled(
  uavId: string,
  detail?: string
): void {
  Logger.warn(TAG, "person detection disabled for stream", { uavId, detail });
  try {
    addAction("privacy_detect_disabled", { uavId, detail });
  } catch {
    /* metrics must never affect video */
  }
}

export function recordModelLoad(ok: boolean, detail?: string): void {
  Logger.info(TAG, ok ? "stephan-best ready" : `stephan-best load failed: ${detail}`);
  try {
    addAction("privacy_model_load", {
      ok,
      detail,
      model: "stephan-best",
      execution: "worker",
    });
  } catch {
    /* metrics must never affect video */
  }
}
